import { NgModule } from '@angular/core';
import { CanDeactivateGuard } from './can-deactivate-guard';
import { RedirectSpacesRoutesGuard } from './redirect-spaces-routes.guard';

@NgModule({
  providers: [CanDeactivateGuard, RedirectSpacesRoutesGuard],
})
export class AppGuardModule {}
